import { render, staticRenderFns } from "./SectionTasks.vue?vue&type=template&id=575469c0&"
import script from "./SectionTasks.vue?vue&type=script&lang=js&"
export * from "./SectionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports